import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store'
import request from "@/utils/request";
import { MessageBox } from "element-ui";
Vue.use(VueRouter);

const routes = [
    // {
    //     path: "/",
    //     name: "login",
    //     component: () => import("../views/login/login.vue"),
    //     meta: {
    //         title: "登录"
    //     },
    // },
    {
        path: "/auth-login",
        name: "auth-login",
        component: () => import("../views/login/auth-login.vue"),
        meta: {
            title: "登录"
        }
    },
    {
        path: "/review-online", //预览pdf文件
        name: "review-online",
        component: () => import("../views/history/review-online.vue"),
        meta: {
            title: "在线预览"
        }
    },
    {
        path: "/review-online", //预览pdf文件
        name: "review-online",
        component: () => import("../views/history/review-online.vue"),
        meta: {
            title: "在线预览"
        }
    },
    {
        path: "/login-register",
        name: "login-register",
        component: () => import("../views/login/login-register.vue"),
        meta: {
            title: "企业注册"
        }
    },
    {
        path: "/", //根路径
        name: "home",
        meta: {
            title: "北京市科委创新创业人才积分落户管理"
        },
        component: () => import("../views/index.vue"), //主布局组件
        children: [
            {
                path: "process", //申报流程
                name: "process",
                component: () => import("../views/process/index.vue"),
                meta: {
                    title: "申报流程"
                }
            },
            {
                //
                path: "to-do-list", //待办事项
                name: "to-do-list",
                component: () => import("../views/to-do-list/index.vue"),
                meta: {
                    title: "待办事项"
                }
            },
            {
                path: "to-info-jiang", //待办事项-申请信息详情
                name: "to-info-jiang",
                component: () => import("../views/to-do-list/to-info-jiang.vue"),
                meta: {
                    title: "待办事项-申请信息详情"
                }
            },
            {
                path: "to-info-gu", //待办事项-申请信息详情
                name: "to-info-gu",
                component: () => import("../views/to-do-list/to-info-gu.vue"),
                meta: {
                    title: "待办事项-申请信息详情"
                }
                //
            },
            {
                path: "to-examine", //待办事项-申请信息详情
                name: "to-examine",
                component: () => import("../views/to-do-list/to-examine.vue"),
                meta: {
                    title: "待办事项-申请信息详情"
                }
            },
            {
                //
                path: "history", //申报材料查看
                name: "history",
                component: () => import("../views/history/index.vue"),
                meta: {
                    title: "申报材料查看"
                }
            },

            {
                //
                path: "info", //企业信息
                name: "info",
                component: () => import("../views/info/index.vue"),
                meta: {
                    title: "企业信息"
                }
            },
            {
                //
                path: "info-look-strand", //企业信息详情-持股类
                name: "info-look-strand",
                component: () => import("../views/info/info-look-strand.vue"),
                meta: {
                    title: "企业信息详情-持股类"
                }
            },
            {
                //
                path: "info-look-awards", //企业信息详情-奖项类
                name: "info-look-awards",
                component: () => import("../views/info/info-look-awards.vue"),
                meta: {
                    title: "企业信息详情-奖项类"
                }
            },
            {
                //
                path: "info-edit-strand", //企业信息修改-持股类
                name: "info-edit-strand",
                component: () => import("../views/info/info-edit-strand.vue"),
                meta: {
                    title: "企业信息修改-持股类"
                }
            },
            {
                //
                path: "info-edit-awards", //企业信息修改-奖项类
                name: "info-edit-awards",
                component: () => import("../views/info/info-edit-awards.vue"),
                meta: {
                    title: "企业信息修改-奖项类"
                }
            },
            {
                //
                path: "register", //企业申请人注册 add-applicant
                name: "register",
                component: () => import("../views/register/index.vue"),
                meta: {
                    title: "企业申请人注册"
                }
            },
            {
                //
                path: "add-applicant", //申请信息详情
                name: "add-applicant",
                component: () => import("../views/register/add-applicant.vue"),
                meta: {
                    title: "企业申请人名单-新增"
                }
            },
            {
                //
                path: "update-applicant", //申请信息详情
                name: "update-applicant",
                component: () => import("../views/register/update-applicant.vue"),
                meta: {
                    title: "企业申请人名单-修改"
                }
            },
            {
                //look-applicant.vue
                path: "look-applicant", //申请信息详情
                name: "look-applicant",
                component: () => import("../views/register/look-applicant.vue"),
                meta: {
                    title: "企业申请人名单-查看"
                }
            },
            {
                path: "enter-audit", //企业审核
                name: "enter-audit",
                component: () => import("../views/enter-audit/index-v2.vue"),
                meta: {
                    title: "企业审核"
                }
            },
            {
                path: "enter-jindu", //企业审核
                name: "enter-jindu",
                component: () => import("../views/enter-audit/jindu.vue"),
                meta: {
                    title: "企业审核"
                }
            },
            {
                path: "complete-jiang", //申请信息详情
                name: "complete-jiang",
                component: () => import("../views/enter-audit/complete-jiang.vue"),
                meta: {
                    title: "申请信息详情"
                }
            },
            {
                path: "complete-gu", //申请信息详情
                name: "complete-gu",
                component: () => import("../views/enter-audit/complete-gu.vue"),
                meta: {
                    title: "申请信息详情"
                }
            },
            {
                path: "password", //修改密码
                name: "password",
                component: () => import("../views/password/index.vue"),
                meta: {
                    title: "修改密码"
                }
            },
            {
                path: "user-manual", //用户手册
                name: "user-manual",
                component: () => import("../views/user-manual/index.vue"),
                meta: {
                    title: "用户手册"
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/kwjfComClient",
    routes
});

const whiteList = ["auth-login", "login-register", "review-online"];
let userExistChecked = false;
let handlingUserNotExist = false;

function getRedListCheckParams() {
    const clientUserInfoStr = sessionStorage.getItem("client-userInfo") || "{}";
    let clientUserInfo = {};
    try {
        clientUserInfo = JSON.parse(clientUserInfoStr);
    } catch (e) {
        clientUserInfo = {};
    }
    return {
        name: clientUserInfo.cn || "",
        pageNum: 1,
        pageSize: 1
    };
}

async function handleUserNotExist(msg) {
    if (handlingUserNotExist) return;
    handlingUserNotExist = true;
    try {
        await MessageBox.alert(msg || "用户不存在", "提示", {
            confirmButtonText: "确定",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: "warning"
        });
    } finally {
        const accessToken = sessionStorage.getItem("Authorization") || "";
        await store.dispatch("user/resetToken");
        window.location.href =
            process.env.VUE_APP_KW_AUTH_BASE_URL +
            "enterpriseAuth/logout?accessToken=" +
            accessToken +
            "&systemType=kwjfComClient";
        handlingUserNotExist = false;
    }
}

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (!store.getters.token && to.name !== "login" && to.name !== "login-register" && to.name !== "auth-login") {
        next({ name: "auth-login" });
        return;
    }

    if (!whiteList.includes(to.name) && !userExistChecked) {
        try {
            await request({
                url: "/user/company/findInRedList",
                method: "post",
                data: getRedListCheckParams(),
                skipLoading: true,
                skipGlobal410: true,
                skipGlobalErrorTip: true
            });
            userExistChecked = true;
        } catch (error) {
            if (Number(error && error.code) === 410) {
                next(false);
                await handleUserNotExist(error.msg);
                return;
            }
        }
    }

    if (whiteList.includes(to.name)) {
        userExistChecked = false;
    }

    if (!handlingUserNotExist) {
        next();
    }
});

export default router;
